import * as AttributesIcons from '../components/AttributesIcons';

export const simpleAttributesIconMap = {
  agile: AttributesIcons.IconAgile,
  empathetic: AttributesIcons.IconEmpathetic,
  leadership: AttributesIcons.IconLeadership,
  team_player: AttributesIcons.IconTeamPlayer,
  inquisitive: AttributesIcons.IconInquisitive,
  observant: AttributesIcons.IconObservant,
  mathematical: AttributesIcons.IconMathematical,
  analytical: AttributesIcons.IconAnalytical,
  composed: AttributesIcons.IconComposed,
  courageous: AttributesIcons.IconCourageous,
  strategic: AttributesIcons.IconStrategic,
  independent: AttributesIcons.IconIndependent,
  perfectionist: AttributesIcons.IconPerfectionist,
  determined: AttributesIcons.IconDetermined,
};

export const selectSimpleAttributeIcon = attributeId => simpleAttributesIconMap[attributeId];

export const iconMap = {
  'special-ops-agile': AttributesIcons.IconAgile,
  'surveillance-officer-agile': AttributesIcons.IconAgile,
  'intel-ops-empathetic': AttributesIcons.IconEmpathetic,
  'agent-handler-empathetic': AttributesIcons.IconEmpathetic,
  'spymaster-empathetic': AttributesIcons.IconEmpathetic,
  'spymaster-leadership': AttributesIcons.IconLeadership,
  'intel-ops-team-player': AttributesIcons.IconTeamPlayer,
  'hacker-inquisitive': AttributesIcons.IconInquisitive,
  'surveillance-officer-observant': AttributesIcons.IconObservant,
  'hacker-mathematical': AttributesIcons.IconMathematical,
  'analyst-analytical': AttributesIcons.IconAnalytical,
  'cryptologist-mathematical': AttributesIcons.IconMathematical,
  'spycatcher-analytical': AttributesIcons.IconAnalytical,
  'agent-handler-composed': AttributesIcons.IconComposed,
  'surveillance-officer-composed': AttributesIcons.IconComposed,
  'special-ops-composed': AttributesIcons.IconComposed,
  'tech_ops-composed': AttributesIcons.IconComposed,
  'tech_ops-inquisitive': AttributesIcons.IconInquisitive,
  'agent-handler-inquisitive': AttributesIcons.IconInquisitive,
  'analyst-inquisitive': AttributesIcons.IconInquisitive,
  'spycatcher-inquisitive': AttributesIcons.IconInquisitive,
  'tech_ops-courageous': AttributesIcons.IconCourageous,
  'special-ops-courageous': AttributesIcons.IconCourageous,
  'spymaster-strategic': AttributesIcons.IconStrategic,
  'cryptologist-independent': AttributesIcons.IconIndependent,
  'spycatcher-perfectionist': AttributesIcons.IconPerfectionist,
  'cryptologist-perfectionist': AttributesIcons.IconPerfectionist,
  'analyst-determined': AttributesIcons.IconDetermined,
  'intel-ops-determined': AttributesIcons.IconDetermined,
  'hacker-determined': AttributesIcons.IconDetermined,
};

const selectAttributesIcon = (attributeId) => {
  if (iconMap[attributeId] === undefined) {
    throw new Error(`No corresponding icon component found for attribute id "${attributeId}"`);
  }

  return iconMap[attributeId];
};

export default selectAttributesIcon;
